<template>
    <transition-group
        tag="ul"
        :class="['pt-upload-list', 'pt-upload-list--' + listType, { 'is-disabled': disabled }]"
        name="pt-list"
    >
        <li
            v-for="file in files"
            :key="file.uid || file"
            :class="['pt-upload-list__item', 'is-' + file.status, focusing ? 'focusing' : '']"
            tabindex="0"
            @keydown.delete="!disabled && handleRemove($event, file)"
            @focus="focusing = true"
            @blur="focusing = false"
            @click="onFileClicked"
        >
            <slot :file="file">
                <img
                    v-if="file.status !== 'uploading' && ['picture-card', 'picture'].includes(listType)"
                    class="pt-upload-list__item-thumbnail"
                    :src="file.url"
                    alt=""
                />
                <a class="pt-upload-list__item-name" @click="handleClick(file)">
                    <i class="pt-icon-document"></i>{{ file.name }}
                </a>
                <label class="pt-upload-list__item-status-label">
                    <i
                        :class="{
                            'el-icon-upload-success': true,
                            'el-icon-circle-check': listType === 'text',
                            'el-icon-check': ['picture-card', 'picture'].includes(listType),
                        }"
                    ></i>
                </label>
                <i v-if="!disabled" class="el-icon-close" @click="handleRemove($event, file)"></i>
                <!-- Due to close btn only appears when li gets focused disappears after li gets blurred, thus keyboard navigation can never reach close btn-->
                <!-- This is a bug which needs to be fixed -->
                <!-- TODO: Fix the incorrect navigation interaction -->
                <i v-if="!disabled" class="el-icon-close-tip">{{ t('pt.upload.deleteTip') }}</i>
                <pt-progress
                    v-if="file.status === 'uploading'"
                    :type="listType === 'picture-card' ? 'circle' : 'line'"
                    :stroke-width="listType === 'picture-card' ? 6 : 2"
                    :percentage="parsePercentage(file.percentage)"
                />
                <span v-if="listType === 'picture-card'" class="pt-upload-list__item-actions">
                    <span class="pt-upload-list__item-preview" @click="handlePreview(file)">
                        <i class="el-icon-zoom-in"></i>
                    </span>
                    <span v-if="!disabled" class="pt-upload-list__item-delete" @click="handleRemove($event, file)">
                        <i class="el-icon-delete"></i>
                    </span>
                </span>
            </slot>
        </li>
    </transition-group>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue';
import { NOOP } from '@vue/shared';

import { t } from '../../locale';
import ElProgress from '../../progress';

import type { PropType } from 'vue';

export default defineComponent({
    name: 'PtUploadList',
    components: { ElProgress },
    props: {
        files: {
            type: Array as PropType<File[]>,
            default: () => [] as File[],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        handlePreview: {
            type: Function as PropType<(file: File) => void>,
            default: () => NOOP,
        },
        listType: {
            type: String as PropType<'picture' | 'picture-card' | 'text'>,
            default: 'text',
        },
    },
    emits: ['remove'],
    setup(props, { emit }) {
        const parsePercentage = (val: string) => {
            return parseInt(val, 10);
        };

        const handleClick = (file: File) => {
            props.handlePreview(file);
        };

        const onFileClicked = (e: Event) => {
            (e.target as HTMLElement).focus();
        };

        const handleRemove = (e: Event, file: File) => {
            emit('remove', file);
        };
        return {
            focusing: ref(false),
            parsePercentage,
            handleClick,
            handleRemove,
            onFileClicked,
            t,
        };
    },
});
</script>
